import { useState, useEffect } from 'react';
import { useApi, githubAuthApiRef } from '@backstage/core-plugin-api';
import { fetchRepos, GithubRepository, RepoFetchOptions } from './githubApi';

interface UseGithubReposResult {
  repos: GithubRepository[];
  loading: boolean;
  error: string | null;
}

export function useGithubRepos(
  owner: string,
  options: RepoFetchOptions = {},
): UseGithubReposResult {
  const [repos, setRepos] = useState<GithubRepository[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const githubAuth = useApi(githubAuthApiRef);

  const { topic, pattern, excludeArchived } = options;

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await githubAuth.getAccessToken(['repo']);
        const result = await fetchRepos(token, owner, { topic, pattern, excludeArchived });
        setRepos(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch repositories');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [githubAuth, owner, topic, pattern, excludeArchived]);

  return { repos, loading, error };
}
